module.exports = __webpack_public_path__ + "img/Pastor f .c8036937.jpg";